export default __webpack_public_path__ + "static/media/arrow-down-9x6.b375e4fb.svg";